import React from "react";
import MdaePopup, {MdaePopupContent, MdaePopupFooter, MdaePopupFooterEndButtons, MdaePopupTitle} from "../../common_components/common_widgets/popup";
import MdaeButton from "../common_widgets/button";
import {TOGGLE_BELL_CURVE_REPORT_WARNING_POPUP} from "./reducers/bell-curve-report-parameter-reducer";

interface IBellCurveReportWarningPopup {
    toggleBellCurveReportWarningPopupVisible: (
        isVisible: boolean
    ) => void;
}

const BellCurveReportWarningPopup: React.FC<IBellCurveReportWarningPopup> = (
    props
  ) => {
    const getPopupTitle = () => {
        return (
          <MdaePopupTitle
            isSmallPopup
            closePopupHandler={() => {
              props.toggleBellCurveReportWarningPopupVisible(false);
            }}
          >
           Warning
          </MdaePopupTitle>
        );
    };
    return (
        <MdaePopup
          deferRendering={false}
          height={260}
          width={500}
          className="bell-curve-report-warning-popup"
          mdaeTitleRender={getPopupTitle}
          mdaeDataUpdaterConfig={[
            {
              actionType: TOGGLE_BELL_CURVE_REPORT_WARNING_POPUP,
              reducerName: "bellCurveReportParameterReducer",
              widgetOptionBindings: {
                visible: "isBellCurveReportWarningPopupVisible",
              },
            },
          ]}
          mdaeContentRender={() => {
            return (
              <div>
                <MdaePopupContent>
                    <div className={"bell-curve-report-notify-popup-content-container"}>
                        <div>
                            <i className={"fa fa-warning warning-icon"} ></i>
                        </div>
                        <div className={"mdae-standalone-label notify-popup-content-label"}>
                            Creation of this report has taken more than 20 seconds. Click ok to continue working while the report is generated. You will receive a notification once the report has completed.
                        </div>
                    </div>
                </MdaePopupContent>
              </div>
            );
          }}
          mdaeFooterRender={() => {
            return (
                <MdaePopupFooter>
                <MdaePopupFooterEndButtons>
                  <MdaeButton
                    id={"pnlBellCurveReportWarningPrimaryBtn"}
                    role={"primary"}
                    onClick={() => {
                      props.toggleBellCurveReportWarningPopupVisible(false);
                    }}
                  >
                    OK
                  </MdaeButton>
                </MdaePopupFooterEndButtons>
              </MdaePopupFooter>
            );
          }}
        ></MdaePopup>
    );
  }

export default BellCurveReportWarningPopup;
